import { render, staticRenderFns } from "./MultiUnitConfirmation.vue?vue&type=template&id=036c1bae"
import script from "./MultiUnitConfirmation.vue?vue&type=script&lang=js"
export * from "./MultiUnitConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports